// extracted by mini-css-extract-plugin
module.exports = {"catalog":"TopCategories_catalog__L0BPg","catalogItemIcon":"TopCategories_catalogItemIcon__VtGAC","catalogNotIndex":"TopCategories_catalogNotIndex__p0D9S"};